import { ForumRemoveOutlineIcon } from './ForumRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D58EAFB0-F7C3-4541-A585-43F80F273833
 * name forum-remove-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-remove-outline.svg
 * tags
 */
export const DiscussionRemoveOutlineIcon = ForumRemoveOutlineIcon;
export default DiscussionRemoveOutlineIcon